import { render, staticRenderFns } from "./TransactionRebitAccount.vue?vue&type=template&id=2c801c2b"
import script from "./TransactionRebitAccount.vue?vue&type=script&lang=js"
export * from "./TransactionRebitAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../website/node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QTable,QTr,QTd,QItem,QItemSection,QAvatar,QIcon,QItemLabel,QBtn,QPopupEdit,QInput});
